import { getComponent } from "../../world/Entity";
import { NavigateCommand } from "../../core/commands/NavigateCommand";
import type { Interaction } from "../Interaction";

export const navigateInteraction: Interaction = {
  id: "navigate",
  label: "Enter",
  isDefault: true,
  canExecute: (ctx) => ctx.entity !== undefined && getComponent(ctx.entity, "portal") !== undefined,
  execute: async (ctx) => {
    ctx.commands.execute(new NavigateCommand(ctx.entity!.id));
    return { success: true };
  },
};
